import React from 'react';
import ServicePageLayout from './ServicePageLayout';

const Stress = () => (
  <ServicePageLayout
    metaTitle="Holistic Stress Management & Resilience Therapy | Therapy with Ayesha"
    title="Holistic Stress Management & Resilience Therapy"
    intro="A grounded, integrative approach to chronic stress — addressing work pressure, relational tension, and emotional overwhelm. We build resilience that lasts beyond the therapy room."
    badges={['Burnout Recovery', 'Boundary Setting', 'Emotional Regulation']}
    sections={[
      {
        heading: 'Stress is a Systemic Signal, Not a Personal Flaw',
        body: "Chronic stress is rarely one big event — it's the cumulative weight of unmet needs, blurred boundaries, and a nervous system that hasn't been allowed to fully exhale in months or years. Therapy maps your specific sources of strain across three core life domains, so we know where to intervene first.",
      },
      {
        heading: 'Three Pillars of Stress We Address',
        pillars: [
          {
            title: 'Work & Professional Stress',
            desc: 'Burnout, corporate pressure, perfectionism, deadline anxiety, imposter syndrome, and the inability to switch off after work. We rebuild your relationship with productivity and rest.',
          },
          {
            title: 'Relationship & Interpersonal Stress',
            desc: "Communication breakdowns, boundary erosion, family or marital friction, people-pleasing patterns. We work on assertive communication and the difficult skill of saying 'no' without guilt.",
          },
          {
            title: 'Emotional Regulation & Overwhelm',
            desc: 'Low frustration tolerance, mood volatility, irritability, emotional flooding, the urge to numb. We build awareness, distress tolerance, and skills to ride emotional waves instead of being capsized by them.',
          },
        ],
      },
      {
        heading: 'How We Work Through Stress in Therapy',
        points: [
          'Identifying your unique stress signature — physical, cognitive, emotional, and behavioural patterns.',
          'Cognitive reframing of perfectionistic and rigid thought patterns that fuel chronic pressure.',
          'Boundary-setting workshops in real time — drafting actual scripts for difficult conversations.',
          'Nervous system regulation: breathwork, grounding, body-based interventions for acute moments.',
          'Lifestyle audit — sleep, movement, screen time, social inputs — and small, sustainable shifts.',
        ],
      },
      {
        heading: 'The Outcome: Resilience, Not Just Relief',
        body: "Stress management isn't about eliminating challenge — life will always be demanding. The real outcome is becoming someone who can absorb pressure, recover quickly, and protect their energy without becoming rigid or withdrawn. You'll leave therapy with a clearer sense of your limits, sharper communication skills, and the felt experience that you can regulate yourself in moments that used to dysregulate you.",
      },
    ]}
  />
);

export default Stress;
